/**
 * Notification Validation Schemas
 * Zod schemas for notification operations
 */

import { z } from "zod";

/**
 * Notification Type Schema
 */
export const notificationTypeSchema = z.enum([
  "job_completed",
  "job_failed",
  "new_result",
  "share_accessed",
  "system",
  "warning",
  "info",
]);

/**
 * Notification Status Schema
 */
export const notificationStatusSchema = z.enum(["unread", "read", "archived"]);

/**
 * Notification Priority Schema
 */
export const notificationPrioritySchema = z.enum([
  "low",
  "normal",
  "high",
  "urgent",
]);

/**
 * Create Notification Schema (Backend only)
 */
export const createNotificationSchema = z.object({
  userId: z.number().int().positive(),
  type: notificationTypeSchema,
  title: z.string().min(1).max(200),
  message: z.string().min(1).max(1000),
  priority: notificationPrioritySchema.optional().default("normal"),
  metadata: z.record(z.unknown()).optional(),
  actionUrl: z.string().url().optional(),
});

/**
 * Update Notification Schema
 */
export const updateNotificationSchema = z.object({
  status: notificationStatusSchema.optional(),
});

/**
 * Update Notification Preferences Schema
 */
export const updateNotificationPreferencesSchema = z.object({
  enableWebPush: z.boolean().optional(),
  enableEmail: z.boolean().optional(),
  enableSound: z.boolean().optional(),
  jobCompleted: z.boolean().optional(),
  jobFailed: z.boolean().optional(),
  newResult: z.boolean().optional(),
  shareAccessed: z.boolean().optional(),
  systemNotifications: z.boolean().optional(),
});

/**
 * Query Notification Schema (GET params)
 */
export const queryNotificationSchema = z.object({
  status: notificationStatusSchema.optional(),
  type: notificationTypeSchema.optional(),
  limit: z
    .string()
    .optional()
    .transform((val) => (val ? parseInt(val, 10) : 50))
    .pipe(z.number().int().min(1).max(100)),
  offset: z
    .string()
    .optional()
    .transform((val) => (val ? parseInt(val, 10) : 0))
    .pipe(z.number().int().min(0)),
});
